import ApiHelper from "../../helpers/ApiHelper";
import BaseService from "../BaseService";

class ImageService extends BaseService {

    static url = "images";
    static apis = {
        getAll: { path: this.url, method: "get" },
    }

    constructor(repo) {
        super(repo);
        this.repo = new ApiHelper("images");
    }

    getAll() {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: ImageService.apis.getAll.path,
                    method: ImageService.apis.getAll.method,
                    authorization: false,
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

}

export default ImageService;